import { Link, useLocation } from "react-router-dom";
import { Phone, AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

const StickyCTA = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation("common");
  const contactPath = pathname.startsWith("/es") ? "/es/contact" : "/contact";

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-foreground border-t border-foreground/20 hidden sm:block">
      <div className="container-max flex items-center justify-between h-12 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-primary-foreground text-sm">
          <AlertTriangle className="h-4 w-4 text-brand-yellow" />
          <span className="font-medium">{t("stickyCta.message")}</span>
        </div>
        <div className="flex items-center gap-4">
          <a href="tel:+13476131717" className="flex items-center gap-2 text-brand-yellow font-semibold text-sm hover:text-brand-yellow/80 transition-colors">
            <Phone className="h-4 w-4" />
            347-613-1717
          </a>
          <Link to={contactPath} className="bg-brand-yellow text-brand-yellow-foreground px-4 py-1.5 text-xs font-semibold uppercase tracking-wider hover:bg-brand-yellow/90 transition-colors rounded-sm">
            {t("stickyCta.freeAssessment")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
